fragment DepartmentGroupFields on DepartmentGroup {
  __typename
  id
  _rowTimestamp
  _isUpdatable
  _isDeletable
  name
  description
  isTravelDepartmentGroup
  departmentGroupItems(orderBy: DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC) {
    nodes {
      id
      _rowTimestamp
      departmentId
      department {
        name
      }
    }
  }
}
